const API_URL =
    process.env.REACT_APP_API_URL ||
    "https://api.cuahangykhoa.com";


/*
 * LẤY USER HIỆN TẠI
 */
const getCurrentUser = () => {

    try {

        const rawUser =
            localStorage.getItem("user");

        if (!rawUser) {
            return null;
        }

        return JSON.parse(rawUser);

    } catch (error) {

        console.error(
            "Không thể đọc user:",
            error
        );

        return null;
    }
};


/*
 * LẤY TOKEN
 */
export const getRehabToken = () => {

    const user =
        getCurrentUser();

    let token =
        user?.token ||
        user?.accessToken ||
        localStorage.getItem("token") ||
        "";

    if (
        typeof token !== "string"
    ) {
        return "";
    }


    token =
        token.trim();


    if (
        token
            .toLowerCase()
            .startsWith("bearer ")
    ) {

        token =
            token
                .slice(7)
                .trim();
    }


    return token;
};


/*
 * KIỂM TRA CÓ THỂ ĐỒNG BỘ DATABASE
 */
export const canSyncRehabData = () => {

    return Boolean(
        getRehabToken()
    );
};


/*
 * LẤY PROFILE ĐANG ĐƯỢC CHỌN
 */
export const getActiveRehabProfileId = () => {

    const value =
        localStorage.getItem(
            "activePatientProfileId"
        );


    if (!value) {
        return null;
    }


    const id =
        Number(value);


    if (
        !id ||
        Number.isNaN(id)
    ) {
        return null;
    }


    return id;
};


/*
 * HEADER
 */
const getHeaders = () => {

    const token =
        getRehabToken();


    return {

        "Content-Type":
            "application/json",

        Authorization:
            token
                ? `Bearer ${token}`
                : "",

        "Cache-Control":
            "no-cache",

        Pragma:
            "no-cache"
    };
};


/*
 * CHỜ TOKEN
 */
const waitForToken = async () => {

    for (
        let i = 0;
        i < 5;
        i++
    ) {

        const token =
            getRehabToken();


        if (token) {
            return token;
        }


        await new Promise(
            (resolve) =>
                setTimeout(
                    resolve,
                    200
                )
        );
    }


    return "";
};


/*
 * KIỂM TRA PROFILE TRƯỚC KHI GỌI API
 */
const requireProfileId = () => {

    const profileId =
        getActiveRehabProfileId();


    if (!profileId) {

        throw new Error(
            "Vui lòng chọn hồ sơ đang theo dõi."
        );
    }


    return profileId;
};


/*
 * LẤY LỊCH SỬ THEO LOẠI
 */
export const getRehabHistory = async (
    trackingType
) => {

    await waitForToken();


    const profileId =
        requireProfileId();


    const response =
        await fetch(
            `${API_URL}/health-tracking/getByType/${trackingType}?profile_id=${profileId}&_t=${Date.now()}`,
            {
                method: "GET",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        let message =
            "Không thể tải dữ liệu phục hồi chức năng.";


        try {

            const errorData =
                await response.json();


            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();


            if (text) {
                message = text;
            }
        }


        throw new Error(
            message
        );
    }


    const result =
        await response.json();


    return (
        result?.data ||
        []
    );
};


/*
 * LẤY TOÀN BỘ DỮ LIỆU
 * CỦA PROFILE ĐANG CHỌN
 */
export const getAllRehabHistory = async () => {

    await waitForToken();


    const profileId =
        requireProfileId();


    const response =
        await fetch(
            `${API_URL}/health-tracking/getAll?profile_id=${profileId}&_t=${Date.now()}`,
            {
                method: "GET",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        let message =
            "Không thể tải dữ liệu phục hồi chức năng.";


        try {

            const errorData =
                await response.json();


            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();


            if (text) {
                message = text;
            }
        }


        throw new Error(
            message
        );
    }


    const result =
        await response.json();


    return (
        result?.data ||
        []
    );
};


/*
 * LƯU DỮ LIỆU
 */
export const saveRehabData = async (
    trackingType,
    trackingData
) => {

    await waitForToken();


    const profileId =
        requireProfileId();


    const response =
        await fetch(
            `${API_URL}/health-tracking/create`,
            {
                method: "POST",

                headers:
                    getHeaders(),

                body:
                    JSON.stringify({

                        profile_id:
                            profileId,

                        tracking_type:
                            trackingType,

                        tracking_data:
                            trackingData
                    })
            }
        );


    if (!response.ok) {

        let message =
            "Không thể lưu dữ liệu phục hồi chức năng.";


        try {

            const errorData =
                await response.json();


            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();


            if (text) {
                message = text;
            }
        }


        throw new Error(
            message
        );
    }


    return await response.json();
};


/*
 * XÓA DỮ LIỆU
 */
export const deleteRehabData = async (
    healthTrackingId
) => {

    await waitForToken();


    const profileId =
        requireProfileId();


    const response =
        await fetch(
            `${API_URL}/health-tracking/delete/${healthTrackingId}?profile_id=${profileId}`,
            {
                method: "DELETE",
                headers: getHeaders()
            }
        );


    if (!response.ok) {

        let message =
            "Không thể xóa dữ liệu.";


        try {

            const errorData =
                await response.json();


            message =
                errorData?.message ||
                message;

        } catch (error) {

            const text =
                await response.text();


            if (text) {
                message = text;
            }
        }


        throw new Error(
            message
        );
    }


    return await response.json();
};